module.exports = __webpack_public_path__ + "no-galleries-created-illustration.5e8331ea2687020ccf5446d2b99a76cd.svg";